import axios from 'axios'
import threeCConfig from './ThreeCConfig'

class ThreeCAuthService {
  constructor () {
    this.token = null
  }

  get baseURL () {
    return threeCConfig.API_BASE_URL
  }

  get user () {
    return threeCConfig.USER
  }

  get password () {
    return threeCConfig.PASSWORD
  }

  get companyDomain () {
    return threeCConfig.DOMAIN
  }

  async authenticate () {
    try {
      // Verificar se a configuração está carregada
      if (!threeCConfig.isLoaded || !threeCConfig.config) {
        throw new Error('Configuração 3C Plus não está carregada')
      }

      // Verificar se as credenciais estão disponíveis
      if (!this.user || !this.password) {
        throw new Error('Credenciais 3C Plus não disponíveis')
      }

      // Verificar se a URL da API está disponível
      if (!this.baseURL) {
        throw new Error('URL da API 3C Plus não configurada')
      }

      console.log('🔐 Fazendo autenticação 3C Plus:', {
        url: `${this.baseURL}/authenticate`,
        user: this.user,
        password: this.password ? '***' : 'VAZIO',
        domain: threeCConfig.DOMAIN,
        company_domain: null,
        configLoaded: threeCConfig.isLoaded
      })

      const response = await axios.post(`${this.baseURL}/authenticate`, {
        user: this.user,
        password: this.password,
        token_type: 'jwt',
        company_domain: null
      })

      if (response.data.data.api_token) {
        this.token = response.data.data.api_token
        console.log('✅ Autenticação 3C Plus bem-sucedida')
        return this.token
      } else {
        throw new Error('Token não encontrado na resposta de autenticação')
      }
    } catch (error) {
      console.error('❌ Erro na autenticação 3C Plus:', {
        url: `${this.baseURL}/authenticate`,
        domain: threeCConfig.DOMAIN,
        status: error.response && error.response.status,
        message: (error.response && error.response.data && error.response.data.message) || error.message
      })

      const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message || 'Erro desconhecido'
      throw new Error(`Falha na autenticação: ${errorMessage}`)
    }
  }

  isAuthenticated () {
    return !!this.token
  }

  getToken () {
    return this.token
  }

  clearToken () {
    this.token = null
  }

  getAuthHeaders () {
    if (!this.token) {
      throw new Error('Token não disponível. Faça a autenticação primeiro.')
    }

    return {
      'Authorization': `Bearer ${this.token}`,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }
}

export default new ThreeCAuthService()



// WEBPACK FOOTER //
// ./src/shared/services/voip/ThreeCAuthService.js